// Pedalokos — Soluções mobile: clone literal de um item nativo do drawer.
(() => {
  if (window.__pdlMobileSolutionsNativeCloneV3) return;
  window.__pdlMobileSolutionsNativeCloneV3 = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const ensureStyles = () => {
    if (document.getElementById('pdl-mobile-solutions-native-clone-v3')) return;

    const style = document.createElement('style');
    style.id = 'pdl-mobile-solutions-native-clone-v3';
    style.textContent = `
      @media screen and (max-width: 749px) {
        .pdl-drawer-solutions__trigger,
        .pdl-drawer-solutions__trigger:hover,
        .pdl-drawer-solutions__trigger:focus-visible,
        .pdl-drawer-solutions__trigger:active {
          background: #f8c10e !important;
          color: var(--menu-top-level-font-color) !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const getNativeTemplateItem = (topMenu) => {
    return Array.from(topMenu.children).find((item) => {
      const details = item.firstElementChild;
      if (!details || details.tagName !== 'DETAILS') return false;
      const summary = details.firstElementChild;
      return summary?.tagName === 'SUMMARY' && summary.getAttribute('on:click') === 'header-drawer/open/submenu';
    });
  };

  const cleanCloneState = (root) => {
    root.querySelectorAll('[aria-current]').forEach((el) => el.removeAttribute('aria-current'));
    root.querySelectorAll('[aria-expanded]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
    root.querySelectorAll('details[open]').forEach((el) => el.removeAttribute('open'));
    root.querySelectorAll('.menu-open').forEach((el) => el.classList.remove('menu-open'));
    root.querySelectorAll('.menu-drawer__menu-item--active').forEach((el) => el.classList.remove('menu-drawer__menu-item--active'));
  };

  const enhance = (source) => {
    if (!mobileQuery.matches || !source?.isConnected) return;

    const navigation = source.closest('.menu-drawer__navigation');
    if (!navigation) return;

    const topMenu = Array.from(navigation.children).find((child) => child.matches?.('ul.menu-drawer__menu.has-submenu'));
    if (!topMenu) return;

    if (topMenu.querySelector('#Details-menu-drawer-pdl-solutions')) {
      source.remove();
      return;
    }

    source.hidden = true;

    const sourceLinks = Array.from(source.querySelectorAll('a.pdl-drawer-tools__item[href]')).filter((link) => {
      if (link.hidden || link.getAttribute('aria-hidden') === 'true') return false;
      return window.getComputedStyle(link).display !== 'none';
    });
    if (!sourceLinks.length) return;

    const templateItem = getNativeTemplateItem(topMenu);
    if (!templateItem) return;

    const clone = templateItem.cloneNode(true);
    cleanCloneState(clone);

    clone.classList.add('pdl-drawer-solutions__list-item');
    clone.style.setProperty('--menu-drawer-animation-index', String(topMenu.children.length + 1));

    const details = clone.firstElementChild;
    const summary = details.firstElementChild;
    const submenu = details.querySelector('.menu-drawer__submenu.has-submenu');
    const backButton = submenu?.querySelector('.menu-drawer__back-button');
    const closeButton = submenu?.querySelector('.menu-drawer__close-button');
    const childList = submenu?.querySelector('ul.menu-drawer__menu--childlist');

    if (!details || !summary || !submenu || !backButton || !closeButton || !childList) return;

    details.id = 'Details-menu-drawer-pdl-solutions';
    summary.id = 'HeaderDrawer-pdl-solutions';
    summary.classList.add('pdl-drawer-solutions__trigger');
    submenu.id = 'link-pdl-solutions';

    const title = source.querySelector('.pdl-drawer-tools__title')?.textContent?.trim() || 'Soluções Pedalokos';
    const summaryText = summary.querySelector('.menu-drawer__menu-item-text');
    const backText = backButton.querySelector('.menu-drawer__menu-item-text');
    if (summaryText) summaryText.textContent = title;
    if (backText) backText.textContent = title;
    backButton.setAttribute('aria-label', `Voltar para ${title}`);

    submenu.querySelectorAll('.menu-drawer__featured-content').forEach((featured) => featured.remove());
    childList.className = 'menu-drawer__menu menu-drawer__menu--childlist';
    childList.replaceChildren();

    sourceLinks.forEach((sourceLink, index) => {
      const item = document.createElement('li');
      item.className = 'menu-drawer__list-item';
      item.style.setProperty('--menu-drawer-animation-index', String(index + 1));

      const link = document.createElement('a');
      link.id = `HeaderDrawer-pdl-solutions-${sourceLink.dataset.pdlDrawerTool || index + 1}`;
      link.href = sourceLink.href;
      link.className = 'menu-drawer__menu-item menu-drawer__menu-item--parent focus-inset';

      const label = document.createElement('span');
      label.className = 'menu-drawer__menu-item-text wrap-text';
      label.textContent = sourceLink.querySelector('span')?.textContent?.trim() || sourceLink.textContent.trim();

      link.appendChild(label);
      item.appendChild(link);
      childList.appendChild(item);
    });

    topMenu.appendChild(clone);
    source.remove();
  };

  const apply = () => {
    if (!mobileQuery.matches) return;
    ensureStyles();
    document.querySelectorAll('[data-pdl-drawer-tools]').forEach(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', () => requestAnimationFrame(apply));

  const headerGroup = document.getElementById('header-group');
  if (headerGroup) {
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        apply();
      });
    }).observe(headerGroup, { childList: true, subtree: true });
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', apply);
  }
})();
